import { number } from "../types/number";

export default function(a) {
  a = number(a);
  return Math.abs(a);
}
